var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCreateTeamAndAddToLeague } from "../api/LeagueApiProvider";
import { Loading } from "../nav/Loading";
import { TeamForm } from "../teams/TeamForm";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { safeReturnTo } from "../utils/safeReturnTo";
import { useNumericParams } from "../utils/useNumericParams";
export var CreateTeamForLeague = function () {
    var leagueId = useNumericParams().id;
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState(undefined), 2), error = _b[0], setError = _b[1];
    var navigate = useNavigate();
    var _c = __read(useSearchParams(), 1), searchParams = _c[0];
    var returnTo = searchParams.get("returnTo");
    var onSuccess = function () {
        navigate(safeReturnTo(returnTo, "/leagues/".concat(leagueId, "/")));
    };
    var onError = function (error) {
        setLoading(false);
        setError(error);
    };
    var mutation = useCreateTeamAndAddToLeague({
        leagueId: leagueId,
        onMutate: function () { return setLoading(true); },
        onSuccess: onSuccess,
        onError: onError,
    });
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!error, message: "Failed to create team. Please try again.", onClose: function () { return setError(undefined); } }), _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { fontSize: { xs: "1.75rem", sm: "2.125rem" } }, children: "Create Team for League" }), _jsx(TeamForm, { onSubmit: mutation.mutate, defaultAddAsPlayer: false, defaultAddAsManager: false })] }));
};
